import {getBaseSDKDataFromContext, getBaseTemplateContext, getFullSDKContext, mergeParams} from "../util"
import {VideoBridgeInit, videoBridgeReportUrls} from "../../api";

// 缓存的 SDK 上下文信息, RewardJs 和 VideoBridge 合并后的结果
let SDKContext_CACHED

// 埋点上报地址
let urlWillReport = `https://analytics.rayjump.com?`

/**
 * 埋点上报组件
 */

/**
 * 上报 H5 埋点
 * TODO: 上报埋点的方式由 "纯 H5 上报" 修改为了 "调用 SDK 的 API: VideoBridge/reportUrls 上报"
 *  所以这里要注意:
 *  后续要基于 mtg-h5 项目开发 "可能会投放在大模板之前的老 SDK 版本" 的模板时 (如 rv/iv 单 offer 模板),
 *  不能直接使用此插件, 需要提前确认一下 VideoBridge/reportUrls API 双端最低支持的 SDK 版本
 *  否则可能会出现低版本 SDK 的埋点上报失效 (安卓之前初步沟通过, 应该是从 9.0.0 开始支持[需要确认])
 * @param reportType 埋点上报类型, 不同类型一般会对应不同的 key
 * @param dataCustomized 埋点上报时要携带的自定义数据, 注意自定义数据会强制覆盖同名的默认数据
 * @returns {boolean}
 */
export async function reportNonBizData({reportType = '', dataCustomized = {}} = {}) {
    // 如果上报类型为空, 直接返回
    if (reportType === '') {
        console.warn('上报类型为空', {reportType, dataCustomized})
        return false
    }

    // 埋点上报时要携带的数据
    let dataWillReport = {}

    // 开始匹配上报类型
    switch (reportType) {
        // 二选一模板 - webviewshow 触发, 且成功展示或播放广告时上报的埋点
        case 'choseFromTwoShow':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'choseFromTwoShow'
            break
        // 二选一模板 - 用户或自动播放触发，即将开始播放任意一个广告时上报的埋点
        case 'choseFromTwoSelect':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'choseFromTwoSelect'
            break
        // 二选一模板 - 用户关闭广告时的埋点上报
        case 'choseFromTwoClose':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'choseFromTwoClose'
            break
        // 先选后播模板 - 展示广告时的埋点上报
        case 'btPlayFirstShow':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstShow'
            break
        // 先选后播模板 - offer2 弹窗展示时的埋点上报
        case 'btPlayFirstDialogShow':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstDialogShow'
            break
        // 先选后播模板 - offer2 弹窗被用户点击时的埋点上报
        case 'btPlayFirstDialogClick':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstDialogClick'
            break
        // 先选后播模板 - offer2 弹窗被用户手动关闭时的埋点上报
        case 'btPlayFirstDialogCloseManual':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstDialogCloseManual'
            break
        // 先选后播模板 - offer2 弹窗倒计时结束自动关闭时的埋点上报
        case 'btPlayFirstDialogCloseAuto':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstDialogCloseAuto'
            break
        // 先选后播模板 - 用户点击广告时的埋点上报
        case 'btPlayFirstClick':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstClick'
            break
        // 先选后播模板 - 用户关闭广告时的埋点上报
        case 'btPlayFirstClose':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstClose'
            break
        // 先选后播模板 - 广告 showfailed 上报
        case 'btPlayFirstAdShowFailed':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstAdShowFailed'
            break
        // 先选后播模板 - 视频关闭需要跳转 endcard，但 endcard 还未加载完成时的埋点上报
        case 'btPlayFirstEndcardShowFailed':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstEndcardShowFailed'
            break
        // 先选后播模板 - webview 因为内存占用等问题导致 webview 被系统 kill 回收时进行的埋点上报
        case 'btPlayFirstWebviewTerminate':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstWebviewTerminate'
            break
        // 先选后播模板 - 通过 VideoBridge/init 获取到的 sdk_info 为 '' 时进行的埋点上报
        case 'btPlayFirstInitSDKVersionEmpty':
            dataWillReport.key = 5000111
            dataWillReport.keyName = 'btPlayFirstInitSDKVersionEmpty'
            break
        // 二选一模板 - 心跳上报
        case 'choseFromTwoHeartbeat':
            dataWillReport.key = 5000112
            dataWillReport.keyName = 'choseFromTwoHeartbeat'
            break
        // ...
        // 代码错误上报
        case 'runtimeError':
            dataWillReport.key = 5000110
            dataWillReport.keyName = 'runtimeError'
            break
        // 如果没有匹配到要上报的埋点类型, 就直接返回, 不再上报
        default:
            console.warn('没有匹配到要上报的埋点类型', {reportType, dataCustomized})
            return false
    }

    // 基础埋点数据
    dataWillReport = Object.assign({}, dataWillReport, getBaseTemplateContext())

    // SDK 相关数据, 如果缓存过就直接获取
    if (SDKContext_CACHED) {
        finalReport({dataCustomized})
    } else {
        // 否则就异步获取
        // getFullSDKContext({
        //     succ: function (fullSDKContext) {
        //         SDKContext_CACHED = fullSDKContext
        //         finalReport({dataCustomized})
        //     }
        // })

        // 注意: 安卓老版本(如 8.13.0)中的 VideoBridgeInit 可能不会返回 unit_id, 这里需要注意
        SDKContext_CACHED = await VideoBridgeInit()
        finalReport({dataCustomized})
    }

    // 最后拼装 "SDK 上下文" 和 "自定义数据" 进行上报
    function finalReport({dataCustomized}) {

        // 拼装 SDK 上下文
        dataWillReport = Object.assign({}, dataWillReport, getBaseSDKDataFromContext(SDKContext_CACHED))

        // 最后发送前, 将自定义数据合并进来
        dataWillReport = Object.assign({}, dataWillReport, dataCustomized)

        // 发送埋点上报, 不再使用 H5 script 方式
        // _reportUrl(urlWillReport + mergeParams(dataWillReport))
        videoBridgeReportUrls([{url: urlWillReport + mergeParams(dataWillReport)}])

        dataWillReport = {}
    }

}

export function openRuntimeErrorReport() {
    /**
     * @param {String}  errorMessage   错误信息
     * @param {String}  scriptURI      出错的文件
     * @param {Number}  lineNumber     出错代码的行号
     * @param {Number}  columnNumber   出错代码的列号
     * @param {Object}  errorObj       错误的详细信息，Anything
     */
    window.onerror = (errorMessage, scriptURI, lineNumber, columnNumber, errorObj) => {
        reportNonBizData({
            reportType: 'runtimeError',
            dataCustomized: {
                errorMessage, scriptURI, lineNumber, columnNumber, errorObj
            }
        })
    }
}